<br>
<div class="row">
	<div class="col-12" align="left">
		<h3><strong>List of Employee Users</strong></h3>
	</div>
</div>
<div class="row">
	<div class="col-12">
		<ngx-datatable class="material striped" [rows]="employeeUsers" [columnMode]="columnMode.force" [headerHeight]="50" [footerHeight]="70" rowHeight="auto" [scrollbarH]="true">
			<ngx-datatable-column prop="isActive" name="" headerClass="cell-center title-header" cellClass="cell-center background-gray" [width]="100" [sortable]="false">
				<ng-template ngx-datatable-header-template>
					<div class="form-check">
						<input class="form-check-input" type="checkbox" [disabled]="disableCheckbox" [checked]="assignAll" (click)="assignAllCallers(row, $event)" />
					</div>
				</ng-template>
				<ng-template let-row="row" ngx-datatable-cell-template>
					<div class="form-check">
						<input class="form-check-input" type="checkbox" [disabled]="disableCheckbox" [checked]="row.assigned" (click)="checkBoxClick(row, $event)" />
					</div>
				</ng-template>
			</ngx-datatable-column>
			<ngx-datatable-column prop="name" name="Name" headerClass="title-header" [width]="200"></ngx-datatable-column>
			<ngx-datatable-column prop="login" name="Login" headerClass="title-header" [width]="200"></ngx-datatable-column>
			<ngx-datatable-footer *ngIf="true">
				<ng-template ngx-datatable-footer-template let-rowCount="rowCount">
					<div class="title-footer"><strong>Total Records: </strong> {{ rowCount }}</div>
				</ng-template>
			</ngx-datatable-footer>
		</ngx-datatable>
	</div>
</div>
